import { NavigationEnd, Router } from '@angular/router';
import { distinctUntilChanged, filter, map, startWith } from 'rxjs';

export const getCurrentPath = (router: Router) =>
  router.events.pipe(
    filter((event: unknown): event is NavigationEnd => {
      return event instanceof NavigationEnd;
    }),
    startWith(null),
    map(() => router.url.split('?')[0]),
    distinctUntilChanged(),
  );
